function SendIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-6 h-6"
    >
      {/* Arrow going right-up (sending) */}
      <line x1="7" y1="17" x2="17" y2="7" />
      <polyline points="7 7 17 7 17 17" />
      {/* Horizontal base line */}
      <line x1="3" y1="21" x2="21" y2="21" />
    </svg>
  )
}

export default SendIcon
